import { render, staticRenderFns } from "./LineText.vue?vue&type=template&id=9ab0f410"
import script from "./LineText.vue?vue&type=script&setup=true&lang=js"
export * from "./LineText.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports